// extracted by mini-css-extract-plugin
export default {"text":"ThxModal_text__B-1JU","secondBtn":"ThxModal_secondBtn__8ZdGO"};